import React, { Component, Fragment, cloneElement } from 'react';
import DropdownNested from './DropdownNested';
import { arrowTopDropdown } from '../svgIcons';
import serverClientUtil from '../../../../utils/serverClientUtil';

/** // TODO: constants hardcode. upgrade */
const travels = 'Viajes y vacaciones';
const interiorDesign = 'Diseño de interiores';
class Dropdown extends Component {
  state = {
    activeNestViajesLink: false,
    activeNestedInteriorDesingLink: false,
  };

  modifyChildren = (child) => {
    const props = {
      className: child.props.className,
    };

    return cloneElement(child, props);
  }

  handleOverNestedMenu = (e) => {
    // if (!links.length) return false;

    const value = e.target.name;
    this.setState({
      activeNestViajesLink: (value === travels),
      activeNestedInteriorDesingLink: (value === interiorDesign),
    });
  }

  handleReleseNestedMenu = (e) => {
    // if (links.length) return false;

    const value = e.target.name;
    this.setState({
      activeNestViajesLink: (value === travels) && false,
      activeNestedInteriorDesingLink: (value === interiorDesign) && false,
    });
  }

  render() {
    const {
      handleOnHoverBtn,
      dataList,
      aboveOtherSitesButton = '',
      aboveServicesButton = '',
      aboveUserBtn = '',
      children = {},
      infoSession,
      stylePosition = '-25px',
    } = this.props;
    const { props = {} } = children;
    const { activeNestViajesLink, activeNestedInteriorDesingLink } = this.state;

    return (
      <div
        className={`dropDownContainer ${aboveUserBtn ? 'dropDownContainerUserBtn' : ''}`}
        style={{ right: stylePosition }}
        onMouseEnter={() => handleOnHoverBtn(true)}
        onMouseLeave={() => handleOnHoverBtn(false)}
      >
        <div>
          <div
            style={{
              height: '10px',
            }}
          >
            { arrowTopDropdown }
          </div>
          <div className="borderRoundTop" />
        </div>
        <ul
          className="resetUlStyles dropdownContent"
        >
          <Fragment>
            { props.children && props.children[0] }
            {
              dataList && dataList.map(({ text, name = '', url, icon = '', links = [], label }, index) => (
                <li key={text}>
                  {/* // TODO: review this implementation for figma. Problem performance!! */}
                  <a
                    href={
                      url.startsWith('http')
                        ? url
                        : serverClientUtil.getLPURL() + url
                    }
                    style={{ position: 'relative' }}
                    className={`${links.length ? 'flexBetween' : 'flexStart'} textIndentEfect`}
                    data-active={(index === 0 || index === (dataList.length - 1))
                      ? 'activeHoverFirstChild'
                      : ''}
                    onMouseEnter={e => this.handleOverNestedMenu(e, links)}
                    onMouseLeave={e => this.handleReleseNestedMenu(e, links)}
                    name={text || label || name}
                    target="_self"
                    rel="noopener noreferrer"
                  >
                    { icon }
                    {
                      (Array.isArray(links) && links.length)
                        ? <DropdownNested
                          dataNested={{
                            title: (text ||label || name),
                            activeNestViajesLink,
                            activeNestedInteriorDesingLink,
                            links,
                          }}
                        />
                        : text || label || name 
                    }
                  </a>
                </li>
              ))
            }
            <li className={'closeSessionBtn'}>{ props.children && props.children[1] }</li>
          </Fragment>
        </ul>
        {/* // TODO: Dinamic brand */}
        <div
          className="borderRoundBottom"
          style={{
            background: (infoSession && infoSession.hasActiveSession) ? '#F5F5F5' : '#FFFFFF',
          }}
        />
      </div>
    );
  }
}

export default Dropdown;
